"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGalleryThumbnail = void 0;
function getGalleryThumbnail(gallery) {
    const { thumbnail_image, images } = gallery;
    if (thumbnail_image) {
        return JSON.parse(thumbnail_image);
    }
    if (images.length) {
        return images[0].uploadcare_image;
    }
    return null;
}
exports.getGalleryThumbnail = getGalleryThumbnail;
//# sourceMappingURL=getGalleryThumbnail.js.map